module.exports = __webpack_public_path__ + "img/logo-ct.1e44a4de.png";